import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createBusiness, updateBusiness, verifyBusiness } from './request';
import { BUSINESS_QUERY_KEY } from '@/api/queries/business/key';
import toast from 'react-hot-toast';

export const useCreateBusiness = (onSuccess?: () => void) => {
  return useMutation({
    mutationFn: createBusiness,
    onSuccess: ({ response }) => {
      toast.success(response);
      onSuccess?.();
    },
  });
};

export const useUpdateBusiness = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateBusiness,
    onSuccess: ({ response }) => {
      toast.success(response || 'Business updated successfully');
      queryClient.invalidateQueries({ queryKey: [BUSINESS_QUERY_KEY] });
      onSuccess?.();
    },
  });
};

export const useVerifyBusiness = (onSuccess?: () => void) => {
  return useMutation({
    mutationFn: verifyBusiness,
    onSuccess: ({ response }) => {
      toast.success(response || 'Business verification submitted successfully');
      onSuccess?.();
    },
    onError: (error: unknown) => {
      const message =
        error instanceof Error
          ? error.message
          : ((error as { response?: { data?: { response?: string } } })
              ?.response?.data?.response ?? 'Verification failed');
      toast.error(message);
    },
  });
};
